module.exports = __webpack_public_path__ + "static/wiz-janowo-4-wide-4da0c00ba841f7963d741ec74e15adde.jpg";